import { render, staticRenderFns } from "./AddHolidayDialog.vue?vue&type=template&id=5cfed2fa&scoped=true&"
import script from "@/views/Roster/AddHolidayDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Roster/AddHolidayDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Roster/add-holiday-dialog.scss?vue&type=style&index=0&id=5cfed2fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfed2fa",
  null
  
)

export default component.exports